<script>
    import {dictionary, locale, _} from "svelte-i18n";
    import {onMount, onDestroy} from 'svelte';
    import {validateEmail} from './lib/Common.svelte';

    export let language = 'ru-RU';
    export let termsUrl = '/terms_of_use';
    export let privacyPolicyUrl = '/privacy_policy';
    export let refundPolicyUrl = '/refund.pdf';
    export let termsAccepted = false;
    export let showEmailInput = true;
    export let tariffs = {};
    export let enableSelfAnalyze = true;
    export let showSelfAnalyzeOption = true;
    export let bindCardPrice = '$1';
    export let showFullAccessButton = false;
    export let email = null;
    export let paymentMode = null;
    export let payment = {};
    export let domain = 'instashpion.ru';

    export let enableReviews = false;

    let serviceName = 'Instashpion';

    switch (domain) {
        case 'datajam.pro':
            serviceName = 'DataJam';
            break;
        case 'instashpion.ru':
        default:
            serviceName = 'Instashpion';
            break;
    }


    function initBtComponents() {
        try {
            jQuery(function () {
                jQuery('[data-toggle="popover"]').popover()
            });
        } catch (err) {
            console.log(err);
        }
    }

    onMount(async () => {
        document.addEventListener('recover-password-dismissed', onRecoverPasswordDismiss);
        initBtComponents();
    });

    onDestroy(async () => {
        document.removeEventListener('recover-password-dismissed', onRecoverPasswordDismiss);
    })

    function onRecoverPasswordDismiss(event) {
        console.log(event.detail);
        email = null;
    }

    let showConsentRequiredError = false;
    let emailError = null;
    let setEmailInProgress = false;

    let currentTariff = {};
    if (language === 'en-US') {
        currentTariff = tariffs.spy[7][3];
    } else {
        currentTariff = enableSelfAnalyze ? tariffs.weekSelf : tariffs.week;
    }

    dictionary.set({
        ru: {
            intro: 'Следите за 10 типами активности пользователя, узнавая, кому он ставит лайки и комменты, что публикует, на кого подписывается и т.п. ' +
                'всего за 1₽ в течение суток.<br><br>' +
                'Пользователь никогда не узнает, что вы шпионите за ним ;)',
            termsAcceptance: 'Я согласен(-на) с <a href="{termsUrl}" target="_blank">Договором оферты</a>\n и <a href="{privacyPolicyUrl}" target="_blank">Политикой конфиденциальности</a>',
            consentRequired: 'Необходимо ваше согласие',
            emailWrongFormatError: 'Неверный формат',
            startTrialMonitoringButtonLabel: 'Начать мониторинг за 1₽',
            emailInputPlaceholder: 'Введите email для получения чека...',
            selfAnalyzeOptionLabel: 'Возможность анализировать свой аккаунт',
            selfAnalyzeDescription: 'Дополнительно к мониторингу интересующих сторонних пользователей, у вас появится возможность анализировать свой собственный аккаунт: смотреть его гостей, кто отписался, убрал лайки, комментарии всего за +300 руб. в неделю',
            selfAnalyzeDescriptionTitle: 'Анализ своего собственного аккаунта',
            fullAccessButtonLabel: 'Полный доступ на 30 дней',
            footerText: 'По истечении тестового периода, стоимость подписки на сервис Инсташпион составит <span class="subscription-sum">{price}</span> руб.' +
                ' за каждые <span class="subscription-period">{period}</span> дней использования, списание которых будет производиться с указанной вами банковской карты. ' +
                'Использование платной подписки на сервис Инсташпион позволит мониторить активность 3-х инстаграм* аккаунтов. ' +
                'Вы вправе отказаться от использования платной подписки в любое время.',
        },
        en: {
            intro: 'Follow 10 types of users activity, finding out who they like and comment, what they publish, who they follow, etc. during 1 day for FREE. It’s safe and anonymous.',
            termsAcceptance: 'I accept <a href="{termsUrl}" target="_blank">User Agreement</a><br>\n and <a href="{refundPolicyUrl}" target="_blank">Refund Policy</a>',
            consentRequired: 'Your consent is required',
            emailWrongFormatError: 'Wrong format',
            startTrialMonitoringButtonLabel: 'Start monitoring for 1$',
            emailInputPlaceholder: 'Enter email to receive a paycheck...',
            footerText: 'To verify your payment method, we’ll charge you $1. ' +
                'We’ll immediately refund that amount after your trial starts. ' +
                'At the end of trial period the cost of subscription to the ' + serviceName + ' service will be ${price} for every {period} days of use, ' +
                'which will be charged from the bank card you specified. ' +
                'Using a paid subscription to the ' + serviceName + ' sevice will allow you to monitor the activity of 3 instagram accounts. ' +
                'You will be able to cancel the subscription at any time.',
        },
    });

    switch (language) {
        case 'ru-RU':
            locale.set('ru');
            break;
        case 'en-US':
        default:
            locale.set('en');
            break;
    }

    function switchSelfAnalyzeOption() {
        enableSelfAnalyze = !enableSelfAnalyze;
        currentTariff = enableSelfAnalyze ? tariffs.weekSelf : tariffs.week;
    }

    function initCardBinding(source = 'dashboard', sourceKey = null, sourceVal) {
        let valid = true;
        const termAgree = termsAccepted;

        if (termAgree === true) {
            showConsentRequiredError = false;
        } else {
            showConsentRequiredError = true;
            valid = false;
        }

        if (language === 'en-US') {
            if (valid && !showEmailInput) {
                buyProcessEn();
            }

            if (validateEmail(email) === true || !showEmailInput) {
                emailError = null;
            } else {
                emailError = $_('emailWrongFormatError');
                valid = false;
            }

            if (valid === true) {
                if (setEmailInProgress === false && showEmailInput) {
                    setEmailInProgress = true;
                    return setEmail(email, sourceKey, sourceVal)
                        .done(function (response) {
                            setEmailInProgress = false;
                            if (response.status === 'ok') {
                                try {
                                    gtag('event', 'begin_checkout', {
                                        'currency': 'USD',
                                        'value': 1,
                                        'items': [
                                            {
                                                'item_name': 'Instashpion trial subscription'
                                            },
                                        ],
                                    });
                                } catch (error) {
                                    console.log(error);
                                }
                                buyProcessEn();
                            } else {
                                if (response.error_code === 'user_exists') {
                                    showUserExistsModal(response.email);
                                } else {
                                    emailError = response.message;
                                }
                            }
                        });
                }
            } else {
                return false;
            }
        } else {

            let agent = 'yandex_kassa';
            if (window._sharedData.altVersion) {
                agent = 'stripe';
            }


            if (valid && !showEmailInput) {
                buyTrial(agent, source, enableSelfAnalyze);
            }

            if (validateEmail(email) === true || !showEmailInput) {
                emailError = null;
            } else {
                emailError = $_('emailWrongFormatError');
                valid = false;
            }

            if (valid === true) {
                if (setEmailInProgress === false && showEmailInput) {
                    setEmailInProgress = true;
                    return setEmail(email, sourceKey, sourceVal)
                        .done(function (response) {
                            setEmailInProgress = false;
                            if (response.status === 'ok') {
                                buyTrial(agent, source, enableSelfAnalyze);
                            } else {
                                if (response.error_code === 'user_exists') {
                                    showUserExistsModal(response.email);
                                } else {
                                    emailError = response.message;
                                }
                            }
                        });
                }
            } else {
                return false;
            }

        }
    }

    function initFullPayment() {
        try {
            let valid = true;
            const termAgree = termsAccepted;

            console.log('Принятие соглашения:', termAgree);

            if (termAgree === true) {
                showConsentRequiredError = false;
            } else {
                console.log('Соглашение не принято!');
                showConsentRequiredError = true;
                valid = false;
            }

            if (validateEmail(email) === true || !showEmailInput) {
                emailError = null;
            } else {
                emailError = $_('emailWrongFormatError');
                valid = false;
            }

            if (valid === true) {
                const count = 3;
                const mode = paymentMode;
                const payment = payment;
                const agent = 'yandex_kassa';

                if (setEmailInProgress === false && showEmailInput) {
                    setEmailInProgress = true;
                    return setEmail(email)
                        .done(function (response) {
                            setEmailInProgress = false;
                            if (response.status === 'ok') {
                                buySpyAnalyzes(agent, count, 30, 0, enableSelfAnalyze);
                            } else {
                                emailError = response.message;
                            }
                        });
                } else {
                    buySpyAnalyzes(agent, count, 30, 0, enableSelfAnalyze);
                }
            } else {
                return false;
            }
        } catch (err) {
            console.log(err);
        }
    }

</script>

<div class="widget-wrap">
    {#if enableReviews}
        <div class="reviews-wrap">
            <div class="review-star"></div>
            <div class="review-star"></div>
            <div class="review-star"></div>
            <div class="review-star"></div>
            <div class="review-star"></div>
        </div>
    {/if}
    <div class="intro-text">
        {@html $_('intro')}
    </div>

    <div>
        <form class="mb-28px" style="text-align: left">
            <label class="check-label mb-24px custom-cb">
                <input type="checkbox" required="" name="agree-terms" checked={termsAccepted}/>
                <span class="square" on:click|preventDefault={(e) => { termsAccepted = !termsAccepted; showConsentRequiredError = false; }}>
                    {#if termsAccepted}
                        <svg width='20' height='13' viewBox='0 0 15 11' fill='none' xmlns='http://www.w3.org/2000/svg'><path
                                d='M4.49976 8.5L1.5831 5.58333C1.50683 5.50613 1.41599 5.44484 1.31586 5.40301C1.21572 5.36118 1.10828 5.33963 0.999763 5.33963C0.891242 5.33963 0.7838 5.36118 0.683666 5.40301C0.583532 5.44484 0.492698 5.50613 0.416429 5.58333C0.339229 5.6596 0.277936 5.75044 0.236103 5.85057C0.19427 5.9507 0.172729 6.05815 0.172729 6.16667C0.172729 6.27519 0.19427 6.38263 0.236103 6.48276C0.277936 6.5829 0.339229 6.67373 0.416429 6.75L3.9081 10.2417C4.2331 10.5667 4.7581 10.5667 5.0831 10.2417L13.9164 1.41667C13.9936 1.3404 14.0549 1.24956 14.0968 1.14943C14.1386 1.0493 14.1601 0.941855 14.1601 0.833335C14.1601 0.724814 14.1386 0.617372 14.0968 0.517238C14.0549 0.417105 13.9936 0.32627 13.9164 0.250001C13.8402 0.172802 13.7493 0.111508 13.6492 0.0696755C13.5491 0.0278426 13.4416 0.00630188 13.3331 0.00630188C13.2246 0.00630188 13.1171 0.0278426 13.017 0.0696755C12.9169 0.111508 12.826 0.172802 12.7498 0.250001L4.49976 8.5Z'
                                fill='#11998E'/></svg>
                    {/if}
                </span>
                <div class="agree-text">
                    {@html $_('termsAcceptance', {
                        values: {
                            termsUrl: termsUrl,
                            privacyPolicyUrl: privacyPolicyUrl,
                            refundPolicyUrl: refundPolicyUrl,
                        },
                    })}
                </div>
                {#if showConsentRequiredError}
                    <div class="error">{$_('consentRequired')}</div>
                {/if}
            </label>

            {#if showEmailInput}
                <div class="form-group" id="email-input-wrap">
                    <input type="text" required=""
                           class="form-control modal-body-input"
                           name="email" placeholder={$_('emailInputPlaceholder')}
                           bind:value={email}
                    />

                    {#if emailError}
                        <div class="error pt-0px">{@html $_(emailError)}</div>
                    {/if}
                </div>
            {/if}

            {#if showSelfAnalyzeOption}
                <div class="clearfix" id="enable-self-analyze-block">
                    <div class="self-account-text">
                        <span>{$_('selfAnalyzeOptionLabel')}</span>
                        <a role="button" class="tip" tabindex="0" data-toggle="popover" data-trigger="focus" title=""
                           data-content={$_('selfAnalyzeDescription')} data-placement="top" data-container="body"
                           data-original-title={$_('selfAnalyzeDescriptionTitle')}
                           style="position: relative; margin-left: 14px">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style="position: absolute; left: -7px;"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 0C4.02991 0 0 4.02991 0 9C0 13.9701 4.02991 18 9 18C13.9701 18 18 13.9701 18 9C18 4.02991 13.9701 0 9 0ZM9 14.2232C8.55603 14.2232 8.19643 13.8636 8.19643 13.4196C8.19643 12.9757 8.55603 12.6161 9 12.6161C9.44397 12.6161 9.80357 12.9757 9.80357 13.4196C9.80357 13.8636 9.44397 14.2232 9 14.2232ZM10.2636 9.81362C10.0817 9.88387 9.92514 10.0073 9.81441 10.1679C9.70368 10.3284 9.6439 10.5186 9.64286 10.7136V11.1696C9.64286 11.258 9.57054 11.3304 9.48214 11.3304H8.51786C8.42946 11.3304 8.35714 11.258 8.35714 11.1696V10.7377C8.35714 10.2737 8.49174 9.81562 8.75692 9.43393C9.01607 9.06027 9.37768 8.775 9.80357 8.61228C10.4866 8.34911 10.9286 7.77656 10.9286 7.15179C10.9286 6.26585 10.0627 5.54464 9 5.54464C7.93728 5.54464 7.07143 6.26585 7.07143 7.15179V7.30446C7.07143 7.39286 6.99911 7.46518 6.91071 7.46518H5.94643C5.85804 7.46518 5.78571 7.39286 5.78571 7.30446V7.15179C5.78571 6.36228 6.13125 5.625 6.75804 5.07656C7.36071 4.54821 8.15625 4.25893 9 4.25893C9.84375 4.25893 10.6393 4.55022 11.242 5.07656C11.8687 5.625 12.2143 6.36228 12.2143 7.15179C12.2143 8.31295 11.4489 9.35759 10.2636 9.81362Z"
                                      fill="#828282"></path>
                            </svg>
                        </a>
                    </div>
                    <div id="self-analyze-checkbox-block" style="float: right">
                        <label class="custom-radio {enableSelfAnalyze ? 'active' : ''}"
                               on:click|preventDefault={(e) => { switchSelfAnalyzeOption() }}>
                            <input type="checkbox" id="enable-self-analyze" name="enable-self-analyze"
                                   checked={enableSelfAnalyze}/>
                            <span class="toggle"></span>
                        </label>
                    </div>
                </div>
            {/if}

            <button class="btn primary-btn" disabled={setEmailInProgress}
                    on:click|preventDefault={(e) => { initCardBinding(); }}>
                {$_('startTrialMonitoringButtonLabel')}
                {#if setEmailInProgress}
                    <img src="/icons/white-preloader.svg" class="white-loader"/>
                {/if}
            </button>
        </form>

        {#if showFullAccessButton}
            <button on:click|preventDefault={initFullPayment}
                    class="btn btn-big btn-success btn-success-pb test-block-bottom-btn btn-success-big-w"
                    disabled={setEmailInProgress}
            >
                {$_('fullAccessButtonLabel')}
                {#if setEmailInProgress}
                    <img src="/icons/white-preloader.svg" class="white-loader"/>
                {/if}
            </button>
        {/if}

        <p class="modal-body-p-bottom hide-for-payment">
            {@html $_('footerText', {
                values: {
                    amount: bindCardPrice,
                    price: currentTariff.totalPrice,
                    period: currentTariff.period,
                },
            })}
        </p>

        {#if domain === 'datajam.pro'}
            <div class="trustpilot__container">
                <a href="https://www.trustpilot.com/review/datajam.pro" target="_blank" class="trustpilot__link">
                    <span class="trustpilot__caption">DataJam is rated <strong>Great</strong></span>
                    <span class="trustpilot__raiting">
                            <span class="trustpilot__arrs">
                                <span class="trustpilot__arrow trustpilot__arrow_active"></span>
                                <span class="trustpilot__arrow trustpilot__arrow_active"></span>
                                <span class="trustpilot__arrow trustpilot__arrow_active"></span>
                                <span class="trustpilot__arrow trustpilot__arrow_active"></span>
                                <span class="trustpilot__arrow trustpilot__arrow_passive"></span>
                            </span>
                            <span class="trustpilot__count">4.2</span>
                        </span>
                    <img src="/img/spy30/trustpilot-logo.svg" alt="" class="trustpilot__logo">
                </a>
            </div>
        {/if}
    </div>
</div>

<style>
    .reviews-wrap {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-bottom: 17px;
    }
    .review-star {
        display: block;
        margin-right: 7px;
        width: 22px;
        height: 21px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 21' %3E%3Cpath d='M21.5355 7.85341H13.3285L10.7935 0.0869598L8.25053 7.85341L0.043457 7.84553L6.68992 12.6503L4.14699 20.4089L10.7935 15.612L17.432 20.4089L14.897 12.6503L21.5355 7.85341Z' fill='%23E7AD4B'/%3E%3Cpath d='M15.4675 14.4068L14.8971 12.6503L10.7936 15.612L15.4675 14.4068Z' fill='%23005128'/%3E%3C/svg%3E");
    }
    .primary-btn {
        font-family: 'Roboto';
        font-style: normal;
        background: rgb(19, 158, 141);
        border-radius: 10px;
        border-color: rgb(19, 158, 141);
        transition: all 0.6s ease 0s;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.015em;
        color: #FFFFFF;
        padding: 17px;
        margin-top: 22px;
        position: relative;
        width: 100%;
        margin-bottom: 0;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
    }

    .custom-radio.active .toggle {
        left: 1.7em;
    }

    .custom-radio .toggle {
        display: block;
        background: #fff;
        top: 4px;
        content: "";
        height: 1em;
        position: absolute;
        width: 1em;
        left: 0.2em;
        transition: .3s;
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.1);
    }

    .custom-radio.active {
        background-color: #139E8D;
    }

    .custom-radio {
        display: block;
        position: relative;
        width: 3em;
        height: 25px;
        cursor: pointer;
        border-radius: 20px;
        border: 1px solid #D9DADC;
        background-color: #fff;
    }

    .error {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #FF0000;
        margin-bottom: 0;
        padding-top: 9px;
    }

    .custom-cb input + span {
        border: 2px solid #11998E;
        border-radius: 0.15em;
        width: 1em;
        height: 1em;
        display: inline-block;
        margin-right: 0.5em;
        /*margin-top: -0.15em;*/
        vertical-align: middle;
        font-size: 22px;
        background: #fff;
    }

    .custom-cb input {
        display: none;
    }

    .check-label {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        display: inline-block;
        text-align: left;
    }

    .mb-24px {
        margin-bottom: 24px;
    }

    .mb-28px {
        margin-bottom: 28px;
    }

    .intro-text {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 23px;
        letter-spacing: 0.015em;
        text-align: left;
        color: #000000;
        margin-bottom: 27px;
    }
    .modal-body-input {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: rgba(130, 130, 130, 0.75);
        padding: 10px 15px;
    }
    .square {
        /*margin-top: -35px !important;*/
    }
    .form-group {
        margin-bottom: 0px;
    }
    .self-account-text {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.015em;
        color: #000000;
    }
    .agree-text {
        display: inline-block;
        max-width: 480px;
        font-size: 14px;
        line-height: 16px;
    }
    @media (max-width: 767px) {
        .square {
            margin-top: -2em;
        }
        .agree-text {
            max-width: 229px;
        }
        .self-account-text {
            max-width: 210px;
        }
        .intro-text {
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 20px;
        }
        .check-label {
            margin-bottom: 18px;
        }
        .primary-btn {
            margin-top: 18px;
        }
        .mb-28px {
            margin-bottom: 22px;
        }
    }
</style>

